<div class="component-loader grid-flex grid-full-center" [class.visible]="loaderVisible">
    <div class="component-loader__spinner"></div>
</div>